import { Injectable } from "@angular/core";
import { BaseProvider } from "../../../shared/providers/base-provider";
import { GeoportalViewNotifier } from "./geoportal-view-notifier";
import { GeoportalViewState } from "./geoportal-view-state";

/**
 * GeoportalViewProvider — trío provider/notifier/state de la vista geoportal.
 *
 * @Injectable() SIN providedIn: se lista en GEOPORTAL_PROVIDERS para que
 * Angular lo escopie al inyector de la ruta y llame ngOnDestroy() al
 * desmontar (estado limpio en cada sesión).
 */
@Injectable()
export class GeoportalViewProvider extends BaseProvider<
  GeoportalViewNotifier,
  GeoportalViewState
> {
  constructor() {
    super(GeoportalViewNotifier);
  }
}
